import React, { ReactNode, FC } from 'react';
import { Card } from '@/features/card/Card';

type Props = {
  currentLabel: React.ReactNode;
  currentValue: React.ReactNode;
  previousLabel?: React.ReactNode;
  previousValue?: React.ReactNode;
  icon: ReactNode;
  classNames?: string;
  boxShadowColor?: string;
};

export const CardStats: FC<Props> = ({
  currentLabel,
  currentValue,
  previousLabel,
  previousValue,
  icon,
  classNames = '',
  boxShadowColor,
}) => (
  <Card className={classNames} boxShadowColor={boxShadowColor}>
    <div className="w-full h-full flex flex-col items-center justify-between relative gap-2">
      <div className="flex flex-row items-center justify-between relative w-full">
        <div>
          <div className="text-sm text-gray-500">{currentLabel}</div>
          <div>{currentValue}</div>
        </div>
        {icon}
      </div>
      {previousLabel &&
        previousValue !== undefined &&
        previousValue !== null && (
          <div className="flex flex-col relative w-full">
            <div className="text-sm text-gray-500">{previousLabel}</div>
            <div className="text-sm ">{previousValue}</div>
          </div>
        )}
    </div>
  </Card>
);
